import React from 'react'

export default function SquareGrid({size=5, color='var(--secondary)', gap=5, number=16, columns=4, className=''}) {

  const squaresRender = Array.from(Array(number).keys()).map((item, index) => {
    return <div 
      key={index}
      style={{ width: size, height: size, background: color }}
    />
  })

  return (
    <div 
      className={`square-grid ${className}`}
      style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, justifyContent: 'center', gap }}
    >
      {squaresRender}
    </div>
  )
}
